import React, { Component } from "react";
//reactstrap components
import { FormGroup, Label, Input, Row } from "reactstrap";

export default class LikertInputCustom extends Component {
  displayError() {
    const error = this.props.error;
    if (typeof error != "undefined" && error != null) {
      return <div className='text-danger'>{error.text}</div>;
    }
  }

  displayValues() {
    return this.props.values.map((selectable, index) => {
      return (
        <FormGroup className="custom-control custom-radio mb-3" key={`${this.props.name}_value_${index}`}>
          <Input
            type='radio'
            className='custom-control-input'
            name={this.props.name}
            id={`${this.props.name}_value_${index}`}
            value={selectable.value}
            checked={this.props.currentValue === selectable.value}
            onChange={(e) => {
              console.log("likert prop name: ", this.props.name);
              this.props.handleChange(this.props.name, e.target.value);
            }}
          />
          <Label className='custom-control-label' htmlFor={`${this.props.name}_value_${index}`}>{selectable.text}</Label>
        </FormGroup>
      );
    });
  }

  render() {
    return (
      <div className={`pt-3 ${typeof this.props.label !== 'undefined' && this.props.label !== null && this.props.label !== "" ? "border-top" : ""}`}>
        {typeof this.props.label !== 'undefined' && this.props.label !== null && this.props.label !== "" &&
          <p className='font-weight-bold mb-4'>{this.props.qIndex}. {this.props.label}</p>
        }
        <Row className='form'>{this.displayValues()}</Row>
        {this.displayError()}
      </div>
    );
  }
}
